module.exports = __webpack_public_path__ + "static/media/carta-consentimiento-datos-personales.fef03049.pdf";